import bannerImg from './banners/woman-helping-man-gym.jpg';

const avaliacaoFisicaPersonal = (t) => ({
    id: 'avaliacao-fisica-personal',
    title: t('templates.items.avaliacaoFisicaPersonal.title'),
    description: t('templates.items.avaliacaoFisicaPersonal.description'),
    indicatedFor: t('templates.audiences.personalTrainers'),
    stepsCount: 2,
    questionsSummary: [
        t('templates.items.avaliacaoFisicaPersonal.summary.trainingGoal'),
        t('templates.items.avaliacaoFisicaPersonal.summary.physicalRestrictions'),
        t('templates.items.avaliacaoFisicaPersonal.summary.availability'),
        t('templates.items.avaliacaoFisicaPersonal.summary.fitnessLevel'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.avaliacaoFisicaPersonal.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.avaliacaoFisicaPersonal.form.profile.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.avaliacaoFisicaPersonal.form.profile.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.avaliacaoFisicaPersonal.form.profile.fullName.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'choices',
                        label: t('templates.items.avaliacaoFisicaPersonal.form.profile.mainGoal.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.avaliacaoFisicaPersonal.form.profile.mainGoal.options.weightLoss') },
                                { id: 'opt-2', label: t('templates.items.avaliacaoFisicaPersonal.form.profile.mainGoal.options.muscleGain') },
                                { id: 'opt-3', label: t('templates.items.avaliacaoFisicaPersonal.form.profile.mainGoal.options.conditioning') },
                                { id: 'opt-4', label: t('templates.items.avaliacaoFisicaPersonal.form.profile.mainGoal.options.health') },
                                { id: 'opt-5', label: t('templates.items.avaliacaoFisicaPersonal.form.profile.mainGoal.options.rehab') },
                            ],
                        },
                    },
                    {
                        order: 3,
                        type: 'choices',
                        label: t('templates.items.avaliacaoFisicaPersonal.form.profile.weeklyDays.label'),
                        description: null,
                        required: true,
                        settings: {
                            options: [
                                { id: 'opt-1', label: t('templates.items.avaliacaoFisicaPersonal.form.profile.weeklyDays.options.two') },
                                { id: 'opt-2', label: t('templates.items.avaliacaoFisicaPersonal.form.profile.weeklyDays.options.three') },
                                { id: 'opt-3', label: t('templates.items.avaliacaoFisicaPersonal.form.profile.weeklyDays.options.four') },
                                { id: 'opt-4', label: t('templates.items.avaliacaoFisicaPersonal.form.profile.weeklyDays.options.fiveOrMore') },
                            ],
                        },
                    },
                ],
            },
            {
                order: 2,
                title: t('templates.items.avaliacaoFisicaPersonal.form.history.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.avaliacaoFisicaPersonal.form.history.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: t('templates.items.avaliacaoFisicaPersonal.form.history.conditioning.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.avaliacaoFisicaPersonal.form.history.conditioning.minLabel'),
                            maxLabel: t('templates.items.avaliacaoFisicaPersonal.form.history.conditioning.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'yes_no_maybe',
                        label: t('templates.items.avaliacaoFisicaPersonal.form.history.injury.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'weight',
                        label: t('templates.items.avaliacaoFisicaPersonal.form.history.currentWeight.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default avaliacaoFisicaPersonal;
